import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import "./style.css";
import backlinkPost from "../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../utils/config";
import Headers from "../Common/Headers";
import Get from "../../../Apis/backlink/Get";
import FindBacklinks from "../popup/FindBacklinks";
import RouteChecker from "../../utils/RouteChecker";
import papa from "papaparse";
// import axios from 'axios';

// export defa

const FetchNewBacklink = ({ fetch }) => {
  const [isBlock, setIsBlock] = useState(true);
  const [mojData, setMojData] = useState([]);
  // const [domainForMoz, setDomainForMoz] = useState("");
  const [loader, setLoader] = useState("first");
  const [searched, setSearched] = useState("");
  const [downloadArr, setDownloadData] = useState([]);
  window.nextpointer = null;
  window.sendRequest = false;
  const [sendRequest, setSendRequest] = useState(false);
  const location = useLocation();
  const [nextPointerCall, setNextPointerCall] = useState(null);
  const [params, setParams] = useState(location.state?.domain);
  const [typeOfParams, setTypeOfParams] = useState(location.state?.type);

  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(false);
  const [index, setIndex] = useState(0);
  const [getAllKeys, setGetAllKeys] = useState([]);
  const [allDomainName, setAllDomainName] = useState([]);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState([]);
  const [openListModel, setOpenListModel] = useState(false);
  const navigation = useNavigate();
  const [lists, setLists] = useState([]);
  const getLists = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Get(url + "/getlistname");
      setLists(res.response);
    } catch (error) {
      console.log(error);
    }
  };
  const getApiKey2 = async () => {
    try {
      const url = getAPIUrlBM();
      const response = await Get(url + "/get/user_moj_api_key");
      if (location.state?.api === "moz" && response.data.length === 0) {
        window
          .sweet({
            text: "Please add Moz API key",
            icon: "warning",
          })
          .then((check) => {
            return navigation("/backlink/user-api-keys", {
              state: { tab: 2 },
            });
          });
      }
      setGetAllKeys(
        response.data.map((item) => {
          return {
            access: item.api_key,
            secret: item.secret,
            token: item.token,
          };
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };
  const getAllDomainName = async () => {
    try {
      const url = getAPIUrlBM();
      const response = await backlinkPost(url + "/getDomainName");
      console.log(response);
      if (Array.isArray(response.data)) {
        const data = response.data.map((item) => {
          return item.domain.replace("http://", "").replace("https://", "");
        });
        setAllDomainName(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApiKey2();
    getAllDomainName();
    getLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.state?.api === "moz") {
      getApiKey2();
    }

    if (location.state?.domain) {
      setParams(location.state?.domain);
      setTypeOfParams(location.state?.type);
      setLoader("first");
      setMojData([]);
      // location change means user want to fetch backlinks again
      // So re initialize the variables when location changes.
      setIsBlock(true);
      setNextPointerCall(null);
    }
  }, [location]);

  useEffect(() => {
    if (isBlock && params) {
      var interval = setInterval(() => {
        // setLoader((prev) => (prev === "first" ? "next_call" : "first"));
        console.log(window.sendRequest, window.nextpointer, "Window State");
        if (!sendRequest) {
          if (nextPointerCall === "") {
            setIsBlock(false);
            setLoader("complete");
            return clearInterval(interval);
          }
          if (location.state?.api === "linkAssistant" || getAllKeys.length)
            callApi(params);
        }
      }, 10000);
      return () => {
        // setIsBlock(false);
        clearInterval(interval);
      };
    }
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBlock, nextPointerCall, sendRequest, getAllKeys, index, params]);
  const callApi = async (target) => {
    let body = {
      target,
      target_scope: typeOfParams,
      api: location.state?.api,
      // filter: 'external+nofollow',
      limit: 1,
      next_token: nextPointerCall,
      backlinkType: location.state?.backlinkType,
    };

    if (location.state?.api === "moz") {
      body = {
        ...body,
        token: getAllKeys[index].token,
        auth: {
          username: getAllKeys[index].access,
          password: getAllKeys[index].secret,
        },
      };
    }

    setSendRequest(true);
    const url = getAPIUrlBM();

    backlinkPost(url + "/discoverBacklinks", body)
      .then(async (response) => {
        // link Assistant limit reached
        if (response.var === "limit") {
          const err = new Error(response.message);
          err.name = "limit";
          throw err;
        }

        if (response?.response?.statusText === "Unauthorized") {
          const err = new Error(response?.response?.message);
          err.response = response.response;
          throw err;
        }

        setSendRequest(false);
        setLoader("next_call");
        window.nextpointer = response.data.next_token.toString();
        setNextPointerCall(response.data.next_token.toString());
        setMojData((prev) => [...response.data.results, ...prev]);
      })
      .catch((error) => {
        setSendRequest(false);
        console.log(error, "Error is coming dear");
        if (error?.name === "limit") {
          window.sweet({
            text: error?.message || "You have reached your limit",
            icon: "error",
          });
        }
        if (
          location.state?.api === "moz" &&
          error?.response?.statusText === "Unauthorized" &&
          index < getAllKeys.length - 1
        )
          setIndex((index) => index + 1);
        else {
          window.sendRequest = false;
          console.error(error);
          window.nextpointer = "";
          setNextPointerCall("");
          setError(error);
          setLoader("complete");
        }
      });
  };
  const [filterDomain, setFilterDomain] = useState({});
  const getBacklinks = async () => {
    try {
      setLoader((prev) => prev === "complete" ?? "first");
      const url = getAPIUrlBM();
      const res = await backlinkPost(url + "/get/backlinks", {
        domain: filterDomain.domain,
        url: filterDomain.search,
      });
      console.log(res.response);
      setMojData(res.response);
      setLoader(0);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!params || nextPointerCall === "") {
      getBacklinks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDomain]);

  const insertBacklink = async () => {
    try {
      // Find the value of select tag which has the name 'curListInFetch'
      const listName = document.getElementsByName("curListInFetch")[0].value;
      // Find the value of select tag which has the name 'curListInFetch'
      console.log(listName);
      if (listName === "") {
        window.sweet({
          text: "Please select a list",
          icon: "warning",
        });
        return;
      }
      const url = getAPIUrlBM();
      const uniqueRes = await backlinkPost(url + "/getUniqueBacklinks", {
        data: checked,
        listId: listName,
      });

      if (uniqueRes.status === "success") {
        const { duplicateCount, uniqueLinks } = uniqueRes.data;
        console.log({ duplicateCount, uniqueLinks });

        const insert = async () => {
          const res = await backlinkPost(url + "/import/backlinks", {
            data: uniqueLinks,
            listId: listName,
          });
          console.log(res);
          if (res.status === "success") {
            window.sweet({
              text: "Backlink inserted successfully",
              icon: "success",
            });
          }
        };

        if (uniqueRes.data.duplicateCount > 0) {
          if (!uniqueLinks.length) {
            window.sweet({
              title: "Alert!",
              text: `All of the selected links are already there in the list.\n\nPlease select other links to add.`,
              icon: "info",
            });
            return;
          }
          window
            .sweet({
              title: "Duplicate Links!",
              text: `${duplicateCount} of the selected links are duplicates or already there in the list.\n\n${uniqueLinks.length} unique links will be added.\n\nDo you want to continue?`,
              icon: "info",
              buttons: {
                cancel: true,
                confirm: true,
              },
            })
            .then((confirm) => {
              if (confirm) {
                insert();
              }
            });
        } else {
          insert();
        }
      }
    } catch (err) {}
  };

  // handle download csv
  const generateCsvData = (data) => {
    const structData = data.map((item) => {
      return {
        "URL Form": item.url_from.replaceAll("'", ""),
        "URL to": item.url_to.replaceAll("'", ""),
        Anchor: `${item.nofollow ? "nofollow" : "dofollow"}`,
        "Rel Tag": `${item.anchor_text || item.anchor}`,
        "Source DA": `${
          item.source?.domain_authority || item.source_domain_authority
        }`,
        "Source PA": `${item.source?.page_authority || item.source_authority}`,
        "Source Spam Rating": `${
          item.source?.spam_score || item.source_spam_score || "---"
        }`,
      };
    });

    const csv = papa.unparse(structData);
    // console.log(csv, deleteAll, "csv");
    return csv;
  };

  const handleDownload = () => {
    console.log(downloadArr);
    if (downloadArr.length <= 0) return;
    const csvData = generateCsvData(downloadArr);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element and click it to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = "data.csv";
    a.click();

    // Cleanup by revoking the object URL
    URL.revokeObjectURL(url);
    document.getElementById("CheckAll").click();
  };

  const header = {
    heading: "Discover Backlinks",
    link: "https://www.loom.com/share/7f338c16d3314cdcb25572ce0249414e",
    subHeading: "Find new backlinks",
    description:
      "With our latest 'Discover Backlinks' feature, you can find new backlinks for your domain or URL. You can reduce the effort to add backlinks for monitoring. Simply find the backlinks & cherry pick the ones that you would want to regularly monitor. We are limited by our crawler's capacity, you might not find all the backlinks of all the sites",
    isSubHeading: true,
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <RouteChecker url="discoverBacklinksScreen">
        <>
          {loader === "first" && (
            <div className="loaderOnFullPage">
              <RotatingLines
                strokeColor="red"
                strokeWidth="4"
                animationDuration="0.75"
                width="74"
                visible={loader === "first"}
              />
            </div>
          )}
          <Headers header={header} />

          <div
            id="hiddenWhenClose"
            style={{
              display: !params || loader === "complete" ? "" : "none",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p className="heading">Filter & Search BackLink</p>
              <button className="successButton" onClick={() => setOpen(true)}>
                Find New Backlinks
              </button>
            </div>
            <div className="linkFilterSection">
              <div className="filterItem1">
                <p className="subHeader"> Search a Domain</p>
                <select
                  disabled={sendRequest}
                  name="curList"
                  // value={listId}
                  onChange={(e) => {
                    if (e.target.value === "all")
                      return setFilterDomain((prev) => ({
                        ...prev,
                        domain: "",
                      }));
                    setFilterDomain((prev) => ({
                      ...prev,
                      domain: e.target.value,
                    }));
                  }}
                >
                  <option value="all">All</option>
                  {allDomainName?.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div
            id="hiddenWhenClose"
            style={{
              display: !params || loader === "complete" ? "" : "none",
            }}
          >
            <p className="subHeader"> Search</p>
            <input
              type="text"
              value={searched}
              placeholder="Search a specific item - ‘Link From’ or ‘Link To’ URL"
              className="searchField"
              onChange={(e) => setSearched(e.target.value)}
            />
            <button
              disabled={sendRequest}
              className="successButton"
              onClick={() =>
                setFilterDomain((res) => {
                  return {
                    ...res,
                    search: searched,
                  };
                })
              }
            >
              Search
            </button>

            {/* <div className="delete_container">
                        <div className="delete_container_1">
                          {deleteAll && (
                            <div className="deleteAll" onClick={DeleteAll}>
                              <span>Delete All</span>
                              <DeleteIcon color={"red"} />
                            </div>
                          )}
                        </div>
                        <div className="delete_container_2">
                          {deleteAll && <span>Bulk Actions</span>}
                          <input
                            type={"checkbox"}
                            onClick={(e) => {
                              // console.log(document.getElementById("deleteAll"));
                              if (e.target.checked) {
                                setDeleteAll(true);
                              } else {
                                setDeleteAll(false);
                              }
                            }}
                          />
                        </div>
                      </div> */}
          </div>

          {loader === "next_call" && (
            <div
              className="bn"
              style={{
                background: "#FFF8D6",
                color: "black",
              }}
            >
              <div className="loader">
                <RotatingLines
                  strokeColor="red"
                  strokeWidth="4"
                  animationDuration="0.75"
                  width="74"
                  visible={true}
                />
              </div>
              <div className="bn-para">
                {location.state?.api === "linkAssistant" ? (
                  <p>We call Link Assistant API every 10 seconds</p>
                ) : (
                  <p>
                    We call Moz's API every 10 seconds because of free plan
                    restrictions.
                  </p>
                )}
                <p>
                  We are continuously adding backlinks on this page, please
                  don't close this tab.
                </p>
                <p>
                  If you close in the middle, the whole process will have to
                  start again. Currently fetched - {mojData?.length}  backlinks
                </p>
              </div>
            </div>
          )}
          {loader === "complete" && (
            <div
              className="bn"
              style={{
                background: "#A9EBD5",
                color: "black",
              }}
            >
              <div className="loader">
                <img src="../green-check.svg" alt="" />
              </div>
              <div className="bn-para">
                <p>We have successfully fetched {mojData?.length} backlinks.</p>
                <p>
                  You can now choose backlinks to shift to one of your lists{" "}
                </p>
                <p>It's safe to close this tab now.</p>
              </div>
            </div>
          )}
          {loader === "error" && (
            <div
              className="bn"
              style={{
                background: "#FFACAC",
                color: "black",
              }}
            >
              <div className="loader">
                <img src="../error-check.svg" alt="" />
              </div>
              <div className="bn-para">
                <p>
                  We encountered an error while fetching backlinks. Here are the
                  error details.
                </p>
                <p>
                  With our latest 'Discover Backlinks' feature, you can find new
                  backlinks for your domain or URL. You can reduce the effort to
                  add backlink
                </p>
              </div>
            </div>
          )}
          {mojData?.length || loader === "complete" ? (
            <div className="linkTable">
              <div
                style={{
                  display: "flex",
                  gap: "5rem",
                  margin: "0.5rem 0",
                  padding: "0.5rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    id="CheckAll"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setDownloadData(mojData);
                        setChecked(
                          mojData?.map((item) => {
                            return item.id;
                          }),
                        );
                      } else {
                        setChecked([]);
                        setDownloadData([]);
                      }
                    }}
                  />
                  <span
                    style={{
                      color: "grey",
                    }}
                    onClick={() => {
                      document.getElementById("CheckAll").click();
                    }}
                  >
                    Select All
                  </span>
                </div>
                <span
                  style={{
                    border: "1px solid #0048A1",
                    color: "#0048A1",
                    padding: "0.25rem 0.5rem",
                    borderRadius: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (checked.length === 0) {
                      window.sweet({
                        title: "Error",
                        text: "Please select atleast one backlink",
                        icon: "error",
                      });
                      return;
                    }
                    setOpenListModel(true);
                  }}
                >
                  Add selected to list
                </span>
                <span
                  style={{
                    border: "1px solid green",
                    color: "green",
                    padding: "0.25rem 0.5rem",
                    borderRadius: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (checked.length === 0) {
                      window.sweet({
                        title: "Error",
                        text: "Please select atleast one backlink",
                        icon: "error",
                      });
                      return;
                    }
                    handleDownload();
                  }}
                >
                  Download Selected
                </span>
              </div>
              <table>
                <tbody>
                  <tr className="tableHead">
                    <th></th>
                    <th
                      className="largeCell"
                      style={{
                        textAlign: "center",
                      }}
                    >
                      URL from
                    </th>
                    <th className="smallCell">URL to</th>
                    <th className="smallCell">Anchor</th>
                    <th className="smallCell">Rel Tag</th>

                    <th className="smallCell">Source DA</th>
                    <th className="smallCell">Source PA</th>
                    <th className="smallCell">Source Spam Rating</th>
                  </tr>
                </tbody>
                {mojData?.map((item) => {
                  return (
                    // <tr>
                    //   <td>{item.source?.page}</td>
                    //   <td>{item.target?.page}</td>
                    //   <td>{item.anchor_text}</td>
                    //   <td>{item.nofollow ? "nofollow" : "dofollow"}</td>
                    //   <td>{item.source?.domain_authority}</td>
                    //   <td>{item.source?.page_authority}</td>
                    //   <td>{item.source?.spam_score}</td>
                    // </tr>
                    <tr className="listTableRow">
                      <td>
                        <input
                          type="checkbox"
                          className="checkbox m-1"
                          checked={checked.includes(item.id)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setDownloadData((res) => {
                                return [...res, item];
                              });
                              setChecked((res) => {
                                return [...res, item.id];
                              });
                            } else {
                              setDownloadData((res) => {
                                return res.filter((i) => i.id !== item.id);
                              });
                              setChecked((res) => {
                                return res.filter((i) => i !== item.id);
                              });
                            }
                          }}
                        />
                      </td>
                      <td
                        className=""
                        style={{
                          maxWidth: "17rem",
                          // border: "1px solid #e0e0e0",
                        }}
                      >
                        <div className="oneLineRow ">
                          {/* eslint-disable-next-line react/jsx-no-target-blank */}
                          <a
                            href={
                              `https://` + (item.source?.page || item.url_from)
                            }
                            target="_blank"
                            className="blueLink"
                          >
                            {item.source?.page || item.url_from}
                          </a>
                        </div>
                      </td>
                      <td
                        className="smallCell"
                        style={{
                          maxWidth: "17rem",
                          // border: "1px solid #e0e0e0",
                        }}
                      >
                        <div className="oneLineRow ">
                          {/* eslint-disable-next-line react/jsx-no-target-blank */}
                          <a
                            href={
                              `https://` + (item.target?.page || item.url_to)
                            }
                            target="_blank"
                            className="blueLink"
                          >
                            {item.target?.page || item.url_to}
                          </a>
                        </div>
                      </td>
                      <td className="smallCell ">
                        {item.nofollow ? "nofollow" : "dofollow"}
                      </td>
                      <td className="smallCell ">
                        {item.anchor_text || item.anchor}
                      </td>
                      <td className="smallCell ">
                        {item.source?.domain_authority ||
                          item.source_domain_authority}
                      </td>
                      <td className="smallCell ">
                        {item.source?.page_authority || item.source_authority}
                      </td>
                      <td className="smallCell ">
                        {item.source?.spam_score ||
                          item.source_spam_score ||
                          "---"}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                flex: 1,
                height: "50%",
              }}
            >
              <p>Sorry, No Backlinks found for this domain in our systems</p>
              <button className="successButton" onClick={() => setOpen(true)}>
                Find Backlinks
              </button>
            </div>
          )}

          {open && (
            <FindBacklinks
              handleClose={() => {
                setOpen(false);
              }}
            />
          )}

          {openListModel && (
            <>
              <div
                className="popup-box"
                onClick={(e) => {
                  const ele = document.getElementById("listPopupHeader");
                  if (e.target !== ele.target && !ele.contains(e.target))
                    setOpenListModel(false);
                }}
              >
                <div
                  // id="inside_div"
                  style={{
                    width: "40%",
                    height: "max-content",
                  }}
                  className="boxx"
                  id="listPopupHeader"
                >
                  <div
                    className="container d-flex flex-row justify-content-between position-sticky fixed-top"
                    style={{ backgroundColor: "#363740", fontSize: "x-large" }}
                  >
                    <div className="text-light my-3">Select List</div>
                    <span
                      className="text-muted px-2 "
                      style={{ fontSize: "xxx-large" }}
                      onClick={() => {
                        setOpenListModel(false);
                      }}
                    >
                      x
                    </span>
                  </div>

                  <div className="boxx-down">
                    <div
                      className="container"
                      style={{
                        paddingTop: "2rem",
                        paddingBottom: "2rem",
                      }}
                    >
                      <div className="px-5 mb-3">
                        <div className="filterItem1 ml-5">
                          <p className="subHeader titleInFindBacklinks ">
                            Select list to add backlinks to
                          </p>
                          <select
                            name="curListInFetch"
                            style={{
                              width: "80%",
                              borderColor: "#ced4da",
                            }}
                          >
                            <option value={""}>
                              Choose the list name from the dropdown
                            </option>
                            {lists?.map((list, index) => (
                              <option value={list.list_id} key={index}>
                                {list.list_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="px-5 d-flex justify-content-center">
                        <button
                          type="button"
                          className=" mt-3 mx-3 rounded-lg btn btn-primary "
                          style={{
                            maxWidth: "15rem",
                            backgroundColor: "#4b2ca9",
                            fontWeight: "500",
                            height: " 3rem",
                            width: "-webkit-fill-available",
                            fontSize: "larger",
                          }}
                          onClick={() => {
                            insertBacklink();
                          }}
                        >
                          Get Backlinks
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      </RouteChecker>
    </div>
  );
};

export default FetchNewBacklink;
